import React, { useRef } from 'react';
import Dropdown from 'react-dropdown';
import cn from 'classnames';

import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import { useTheme } from 'providers/Theme.provider';

import DropdownMenuFooter from 'clientCommunications/components/Clients/common/DropdownMenuFooter.component';

import 'react-dropdown/style.css';
import CN from './LastVisitDropDown.module.scss';

const weeks = [' ', '2 ', '4', '5', '6', '7', '8', '10', '12', '14', '16', '18', '20', '24'];
const ONE_YEAR = 52;
const LastVisitOptions = {
  LAST_7_DAYS: '>7days',
  LAST_YEAR: '<1year',
  NO_VISIT: 'noVisit',
  MORE_THAN_X_WEEKS: (weeks) => weeks.toString(),
};

const isInteger = (value) => parseInt(value) === value;

const LastVisitDropDown = ({
  isLastVisit,
  selectedLastVisit,
  onCheckLatVisit,
  onDoneLastVisit,
  onClearLastVisitSelection,
  selectedNoVisit,
}) => {
  const { isDarkMode } = useTheme();
  const mainContainerRef = useRef(null);

  const handleCheckLastVisit = (value) => {
    onCheckLatVisit(value);
    if (mainContainerRef.current) {
      mainContainerRef.current.scrollTo({
        top: mainContainerRef.current.scrollHeight,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div
      className={cn({
        'drop-down dd-last-visit': true,
        hidden: !isLastVisit,
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <div className="main" ref={mainContainerRef}>
        <span className="span-header">Only show clients whose last visit was</span>
        <div className={CN.container}>
          <div
            className={CN.itemContainer}
            onClick={() => {
              handleCheckLastVisit(LastVisitOptions.LAST_7_DAYS);
            }}
          >
            <div className={CN.itemName}>In the last 7 days</div>
            <Icon variant="radio" selected={selectedLastVisit === LastVisitOptions.LAST_7_DAYS} width="md" />
          </div>

          <div
            className={CN.itemContainer}
            onClick={() => {
              handleCheckLastVisit(LastVisitOptions.LAST_YEAR);
            }}
          >
            <div className={CN.itemName}>Any time in the past year</div>
            <Icon variant="radio" selected={selectedLastVisit === LastVisitOptions.LAST_YEAR} width="md" />
          </div>
          <div
            className={CN.itemContainer}
            onClick={() => {
              handleCheckLastVisit(LastVisitOptions.NO_VISIT);
            }}
          >
            <div className={CN.itemName}>{selectedNoVisit ? 'No visits' : 'Has not visited before'}</div>
            <Icon variant="radio" selected={selectedLastVisit === LastVisitOptions.NO_VISIT} width="md" />
          </div>

          <div
            className={CN.itemContainer}
            onClick={(e) => {
              handleCheckLastVisit(e.value);
            }}
          >
            <div className={CN.itemName}>
              <div className={CN.weeksContainer}>
                <div> More than</div>
                <Dropdown
                  className={CN.weeks}
                  controlClassName="react-dropdown"
                  menuClassName={CN.weekDropdown}
                  options={weeks}
                  onChange={(e) => {
                    handleCheckLastVisit(e.value);
                  }}
                  value={isInteger(parseFloat(selectedLastVisit)) ? selectedLastVisit : weeks[0]}
                  arrowClosed={<span className="arrow-closed" />}
                  arrowOpen={<span className="arrow-open" />}
                />
                <div> weeks ago</div>
              </div>
            </div>
            <Icon
              variant="radio"
              selected={isInteger(parseFloat(selectedLastVisit)) && parseFloat(selectedLastVisit) !== ONE_YEAR}
              width="md"
            />
          </div>

          <div
            className={CN.itemContainer}
            onClick={() => {
              handleCheckLastVisit(LastVisitOptions.MORE_THAN_X_WEEKS(ONE_YEAR));
            }}
          >
            <div className={CN.itemName}>More than 1 year ago</div>
            <Icon
              variant="radio"
              selected={selectedLastVisit === LastVisitOptions.MORE_THAN_X_WEEKS(ONE_YEAR)}
              width="md"
            />
          </div>
        </div>
        <DropdownMenuFooter>
          <Button variant="slim" onClick={onClearLastVisitSelection}>
            CLEAR
          </Button>
          <Button variant="slim" onClick={onDoneLastVisit}>
            DONE
          </Button>
        </DropdownMenuFooter>
      </div>
    </div>
  );
};

export default LastVisitDropDown;
